<template>
  <el-collapse :value="status < 4 ? '1' : ''">
    <el-collapse-item name="1">
      <template #title>
        <div style="margin-left: 7px;">
        <i class="fa-solid fa-wrench"></i>
        &nbsp;
        <span>{{$t('Təmir_mərkəzində_qiymətləndirmə')}}</span>
        </div>
      </template>
      <card>
        <div class="row">
          <div class="col-9"></div>
          <div class="col-3">
            <div class="text-center" :class="status ? statusColor(status) : ''">
              <span style="font-size: 11pt; color: white">
                {{ item.techExpertStatusName }}
              </span>
            </div>
          </div>
        </div>
        <el-form ref="initialForm" :disabled="readonly" :rules="rules" :model="item" v-loading="loading"
          :label-position="labelPosition" :validate-on-rule-change="false">
          <div>
            <div class="row">
              <div class="col-md-4">
                <el-form-item :label="$t('Təmir_mərkəzi')" prop="serviceCenterId" class="service-center-item">
                  <service-centers-el :readonly="readonly" :size="'normal'" v-model="item.serviceCenterId" />
                </el-form-item>
              </div>
            </div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('İlkin_məbləğ')" prop="initialServiceSum">
                  <el-input size="small" v-decimal v-model="item.initialServiceSum"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="initialServiceNote">
                  <el-input size="small" v-model="item.initialServiceNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 45px">
                <el-button v-if="!readonly" size="small" :disabled="saveloading" type="primary"
                  @click="save(3)">{{$t('Yadda_saxla')}}</el-button>
                <created-label v-if="item.initialServiceDateStr" :type="2" :class="{ 'higher-position': readonly }"
                  :created="item.initialServiceDateStr" />
              </div>
            </div>
            <div class="custom-upload-left">
              <dir class="col-12">
                <upload ref="upload" :disabled="readonly" :sourcetype="10" :sourceId="item.claimId" :autoupload="true"
                  :downloadAll="false"></upload>
              </dir>
            </div>
          </div>
        </el-form>
        <hr v-if="isInitialServiceSumValid">

        <el-form ref="offeredForm" :disabled="readonly" :rules="rules" :model="item" v-if="isInitialServiceSumValid"
          :label-position="labelPosition" :validate-on-rule-change="false">
          <div class="row" style="padding-bottom: 10px">
            <div class="col-md-4">
              <el-form-item :label="$t('Təklif_olunan_məbləğ')" prop="offeredServiceSum">
                <el-input size="small" v-decimal v-model="item.offeredServiceSum">
                </el-input>
              </el-form-item>
            </div>

            <div class="col-md-4">
              <el-form-item :label="$t('Qeyd')" prop="offeredServiceNote">
                <el-input size="small" v-model="item.offeredServiceNote"></el-input>
              </el-form-item>
            </div>
            <div class="col-md-4" style="margin-top: 45px">
              <el-button size="small" v-if="!readonly" :disabled="saveloading" type="primary"
                @click="save(4)">{{$t('Yadda_saxla')}}</el-button>
              <created-label v-if="item.offeredServiceDateStr" :type="2" :class="{ 'higher-position': readonly }"
                :created="item.offeredServiceDateStr" />
            </div>
          </div>
          <div class="custom-upload-left">
            <dir class="col-12">
              <upload ref="upload" :disabled="readonly" :sourcetype="11" :sourceId="item.claimId" :autoupload="true"
                :downloadAll="false"></upload>
            </dir>
          </div>

        </el-form>
        <hr v-if="isOfferedServiceSumValid">
        <el-form ref="finalForm" :disabled="readonly" :rules="rules" :model="item" v-if="isOfferedServiceSumValid"
          :label-position="labelPosition" :validate-on-rule-change="false">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('Yekun_məbləğ')" prop="finishServiceSum">
                  <el-input size="small" type="number" :readonly="status >= 6 || readonly"
                    v-model="item.finishServiceSum">
                  </el-input>
                </el-form-item>
              </div>
              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="finishServiceNote">
                  <el-input size="small" :readonly="status >= 6 || readonly"
                    v-model="item.finishServiceNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 45px">
                <el-button size="small" v-if="!readonly" :disabled="saveloading" type="primary"
                  @click="save(5)">{{$t('Yadda_saxla')}}</el-button>
                <created-label v-if="item.finishServiceDateStr" :class="{ 'higher-position': readonly }" :type="2"
                  :created="item.finishServiceDateStr" />
              </div>
            </div>
            <div class="custom-upload-left">
              <dir class="col-12">
                <upload ref="upload" :disabled="readonly" :sourcetype="12" :sourceId="item.claimId" :autoupload="true"
                  :downloadAll="false"></upload>
              </dir>
            </div>

          </div>

        </el-form>

        <card>
          <div style="display: flex; align-items: center;">
            <img src="hucarep.jpg" alt="Carep Logo" style="height:50px; margin-left: 10px;" />
            <h5 style="margin-left: 15px;">{{$t('Göndərişlər')}}</h5>
          </div>

          <hr width="100%" size="50" style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
            align="center">
          <div class="referrals-container">
            <div v-for="(referral, index) in referrals" :key="index" @dblclick="navigateToReferral(referral.referralId)"
              class="referral-wrapper">
              <referral-card :referral="typeof referral === 'object' ? referral : {}" class="referral-card" />
            </div>
          </div>
        </card>

      </card>
    </el-collapse-item>
  </el-collapse>
</template>


<script>
  import CreatedLabel from "./CreatedLabel.vue";
  import Upload from "./Upload.vue";
  import { UpdateTechExpert } from "../../services/claim";
  import ServiceCentersEl from "../components/ServiceCentersEl.vue";
  import ReferralCard from "../components/ReferralCard.vue";
  import { GetApiToken, GetClaimReferralsById, GetCarepReferral } from "../../services/carep";
  import { labelPosition } from "../../services/helper";
  export default {
    components: {
      Upload,
      ServiceCentersEl,
      CreatedLabel,
      ReferralCard,
    },
    props: {
      value: Object,
      readonly: { type: Boolean, default: false },
      service: String
    },
    data() {
      return {
        loading: false,
        item: this.value,
        status: this.value.status,
        uid: this.$store.state.user.id,
        saveloading: false,
        referrals: [],
        claimId: null,
        labelPosition: labelPosition,
      };
    },
    computed: {
      isInitialServiceSumValid() {
        return this.item.initialServiceSum && this.item.initialServiceSum !== 0;
      },
      isOfferedServiceSumValid() {
        return this.item.offeredServiceSum && this.item.offeredServiceSum !== 0;
      },
      rules() {
        return {
          serviceCenterId: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          initialServiceSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          offeredServiceSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          finishServiceSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
        }
      },
    },
    methods: {
      statusColor(status) {
        switch (status) {
          case 5:
            return "p-2 mb-2 bg-info text-dark rounded";
          case 6:
            return "p-2 mb-2 bg-warning text-dark rounded";
          case 7:
            return "p-2 mb-2 bg-success text-dark rounded";
          case 8:
            return "p-2 mb-2 bg-warning text-dark rounded";
          case 11:
            return "p-2 mb-2 bg-danger text-dark rounded";
          default:
            return "text-default";
        }
      },
      save(stage) {
        let formRef;
        if (stage === 3) formRef = 'initialForm';
        else if (stage === 4) formRef = 'offeredForm';
        else if (stage === 5) formRef = 'finalForm';

        this.$refs[formRef].validate((valid) => {
          if (valid) {
            this.saveloading = true;
            this.item.stage = stage;
            this.item.commandUserId = this.uid;
            UpdateTechExpert(this.item).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Uğurlu_əməliyyat'),
                  });
                  this.$emit("refresh");
                  setTimeout(() => {
                    this.saveloading = false;
                  }, 5000);
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          }
        });
      },

      initializeClaimId() {
        const pathSegments = this.$route.path.split('/');
        this.claimId = pathSegments[pathSegments.length - 1];

        if (this.claimId) {
          this.getClaimReferrals();
        } else {
        }
      },
      async getClaimReferrals() {
        if (this.claimId) {
          try {
            const response = await GetClaimReferralsById(this.claimId, '0');
            this.referrals = Array.isArray(response.data.data) ? response.data.data : [];
       
            await this.initializeData();
          } catch (error) {
               console.error(this.$t('API_hatası'), error);
    this.$message.error('Error loading referralsss data');
          }
        } else {
          console.warn('Claim ID not found');
        }
      }
      ,
      navigateToReferral(referralId) {
        if (referralId) {
          const url = `/#/carep/${referralId}`;
          window.open(url, '_blank');
        }
      },
      async initializeData() {
        try {
          const tokenResponse = await GetApiToken();
          const jwtToken = tokenResponse.result.jwt;

          this.referrals = await Promise.all(
            this.referrals.map(async (referral) => {
              const referralDataResponse = await GetCarepReferral(referral.referralId, jwtToken);

              if (referralDataResponse && referralDataResponse.result) {
                this.$set(referral, 'status', referralDataResponse.result.status);
                this.$set(referral, 'statusName', referralDataResponse.result.statusname);
              } else {
                console.warn(`No valid status information found for Referral ID ${referral.referralId}.`);
              }
              return referral;
            })
          );

        } catch (error) {
          console.error("initializeData error:", error);
        }
      }


    },
    mounted() {
      this.initializeClaimId();
      this.$nextTick(() => {
        if (this.$refs.initialForm) this.$refs.initialForm.clearValidate();
        if (this.$refs.offeredForm) this.$refs.offeredForm.clearValidate();
        if (this.$refs.finalForm) this.$refs.finalForm.clearValidate();
      });
    },

    watch: {
      value() {
        this.status = this.value.status;
        this.item = this.value;

      },
    },
  };
</script>

<style lang="scss" scoped>
  .custom-form-item {
    margin-bottom: 0 !important;
  }

  .custom-upload-left {
    margin-left: -15px;
    margin-top: -20px;
  }

  .record-label {
    font-size: var(--font-primary);
    font-style: italic;
  }

  .service-center-width {
    width: 380px;
  }

  .higher-position {
    margin-top: 10px;
  }

  .referrals-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: start;
  }

  .referral-card {
    border: 1px solid #ccc;
    padding: 4px;
    border-radius: 4px;
    font-size: 0.8rem;
    cursor: pointer;
    display: block;
    flex: 1 0 calc(33% - 10px);
    box-sizing: border-box;
  }
</style>